import { Action, Reducer } from "redux";
import HeaderState from "../State/HeaderState";
import { ActionType } from "../Actions/ActionTypes";


const actionOnMenu = (oldState: HeaderState, action: Action): HeaderState => {
    return { ...oldState, menu: !oldState.menu }
}


type Process = (oldState: HeaderState, action: Action) => HeaderState

export const HeaderReducer: Reducer<HeaderState, Action> = (state: HeaderState = { menu: false }, action: Action): HeaderState => {

    let actionMap = new Map<ActionType, Process>()
    actionMap.set(ActionType.ON_MENU, actionOnMenu)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


